/**
 *
 * @module subscriptionClientEndpoint
 * @see https://github.com/STRML/keyMirror
 *
 */

/* eslint new-cap: 'off' */

import KeyMirror from 'keymirror';

/**
 *
 * @typedef SubscriptionClientEndpoint
 * @type {Object}
 *
 * @property {String} getSubscriptions
 * @property {String} linkSubscriptionsFromDevice
 *
 */

/**
 *
 * @enum
 * @type {SubscriptionClientEndpoint}
 *
 */
export default KeyMirror({
    /**
     *
     * @access public
     * @type {String}
     *
     */
    getSubscriptions: null,
    /**
     *
     * @access public
     * @type {String}
     *
     */
    linkSubscriptionsFromDevice: null
});



// WEBPACK FOOTER //
// ./src/services/subscription/subscriptionClientEndpoint.js